/* eslint-disable no-redeclare */
<template>
  <div>
    <navbar :title="title"></navbar>
    <div style="padding-top: 80px; background: #fbfbfb">
      <div class="personalMsg-title">
        <img :src="staticImage + 'personalMsgIcon.png'" />
        <span>个人信息</span>
      </div>

      <div class="personalMsg">
        <div class="owner-pic">
          <template v-if="submitData.ryzp">
            <div>
              <img
                :src="submitData.ryzp"
                @click="showPic"
                style="width: 100%; height: 100%; object-fit: contain"
              />
              <div class="DelImg" @click="DelImg(2)">
                <img src="../../public/close.png" />
              </div>
            </div>
          </template>
          <template v-else>
            <div @click="showFloat(2)">
              <span class="jia">+</span>
              <span class="text">上传正面人脸照</span>
            </div>
          </template>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%">
            姓名：
            <input
              v-model="submitData.xm"
              style="width: 81%"
              placeholder="请输入姓名"
              placeholder-style="color:#bfbfbf;font-size: 16px;"
            />
          </div>
        </div>
        <div class="owner-item">
          <div style="display: flex; width: 100%">
            身份证号：
            <input
              placeholder="请输入身份证号"
              placeholder-style="color:#bfbfbf"
              maxlength="18"
              v-model="submitData.zjhm"
            />
          </div>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%">
            手机号码：
            <input
              placeholder="请输入手机号码"
              placeholder-style="color:#bfbfbf"
              maxlength="11"
              v-model="submitData.sjhm"
            />
          </div>
        </div>
      </div>

      <div class="houseMsg-title">
        <img :src="staticImage + 'houseMsgIcon.png'" />
        <span>房屋信息</span>
      </div>
      <div class="picker">
        <div class="picker-item">
          小区
          <template v-if="hasVillage">
            <!-- <select class="house_select" v-model="village" @change="villagePickersrChange">
              <option v-for="(i,index) in villagePickers" :value="i.id" :key="index">{{i.xqmc}}</option>
            </select>-->
            <el-select
              v-model="submitData.visitorsRecordDomain.xqid"
              placeholder="请选择"
              @change="villagePickersrChange"
            >
              <el-option
                v-for="item in villagePickers"
                :key="item.id"
                :label="item.xqmc"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <div class="picker-select" style="color: #bfbfbf">暂无可选小区</div>
          </template>
        </div>

        <div class="picker-item">
          楼栋
          <template v-if="hasBuildings">
            <el-select
              v-model="submitData.visitorsRecordDomain.ldid"
              placeholder="请选择"
              @change="buildingsPickerChange"
            >
              <el-option
                v-for="item in buildingsPickers"
                :key="item.buildingId"
                :label="item.buildingLabel"
                :value="item.buildingId"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <div class="picker-select" style="color: #bfbfbf">暂无可选楼栋</div>
          </template>
        </div>

        <div class="picker-item">
          单元
          <template v-if="hasUnit">
            <el-select
              v-model="unit"
              placeholder="请选择"
              @change="unitPickerChange"
            >
              <el-option
                v-for="item in unitPickers"
                :key="item.unitNo"
                :label="item.unitname"
                :value="item.unitNo"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <div class="picker-select" style="color: #bfbfbf">暂无可选单元</div>
          </template>
        </div>
        <!-- <div class="picker-item">
          楼层
          <template v-if="hasLevel">
            <select class="house_select" v-model="level" @change="levelPickerChange">
              <option value>请选择</option>
              <option
                v-for="(i,index) in levelPickers"
                :value="i.levelNo"
                :key="index"
              >{{i.levelname}}</option>
            </select>
          </template>
          <template v-else>
            <div class="picker-select" style="color:#bfbfbf;">暂无可选楼层</div>
          </template>
        </div> -->

        <div class="picker-item">
          房号
          <template v-if="hasHouse">
            <el-select
              v-model="submitData.visitorsRecordDomain.fwid"
              filterable
              placeholder="请选择"
              @change="housePickerChange"
            >
              <el-option
                v-for="item in housePickers"
                :key="item.id"
                :label="item.roomNo"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <div class="picker-select" style="color: #bfbfbf">暂无可选房屋</div>
          </template>
        </div>
      </div>
      <div class="submit-btn" @click="submit">
        <span>提交</span>
      </div>
    </div>

    <div v-if="showFace">
      <div class="showId">
        <div class="showId-view">
          <div @click="hideFloat" class="close">
            <img src="../../public/close.png" />
          </div>
          <img src="../../public/updateFace.png" />
          <!-- <div class="showId-btn" @click="updateFacePic">点击上传人脸照片</div> -->
          <a href="javascript:;" class="file">
            点击上传人脸照片
            <input
              type="file"
              @change="updateFacePic($event)"
              accept="image/*"
              id="uploadFile"
              name
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  /* eslint-disable */
  data() {
    return {
      showUpload: false,
      showFace: false,
      title: "来访管理", // 页面标题
      staticImage: this.$common.staticImage, // 静态图片地址
      villagePickers: [], // 小区pickers
      buildingsPickers: [], // 楼栋pickers
      unitPickers: [], // 单元pickers
      levelPickers: [], // 楼层pickers
      housePickers: [], // 房屋pickers
      hasVillage: false, // 是否有小区
      hasBuildings: false, // 是否有楼栋
      hasUnit: false, // 是否有单元
      hasLevel: false, // 是否有楼层
      hasHouse: false, // 是否有房屋
      submitData: {
        visitorsRecordDomain: {
          jllx: 2, //记录类型
          fklx: null, //访客类型
          jlrid: 1, //记录人id
          fwid: null, // 房屋id
          fwxx: null, //房屋信息
          ldid: null, //楼栋id
          xqid: null // 小区id
        },
        xm: null,
        ryzp: null,
        zjhm: null,
        sjhm: null,
        fwzt: 1
      }, // 提交数据对象
      villageParams: {}, // 获取小区请求数据
      buildingParams: {
        communityId: null, // 小区id
        xqbm: null // 小区编码
      }, // 获取楼栋请求数据
      housesParams: {
        communityId: null, // 小区id
        buildingId: null, // 楼栋id
        dyh: null // 单元号
        // level: null, //楼层
      }, // 获取房屋时请求数据
      a: {
        picData: null
      }, // 人脸照片剪裁请求数据
      unit: null,
      unitObj: null, // 获取单元时的一个中间data变量
      touched: true, // 是否可以点击提交按钮
      xqmc: null,
      ldmc: null,
      dyh: null,
      room: null
    };
  },
  mounted() {
    var that = this;
    that
      .post("api-apmuc/communityRest/queryCommunitys", that.villageParams)
      .then(res => {
        if (res.data.length) {
          that.hasVillage = true;
          that.villagePickers = res.data;
          that.submitData.visitorsRecordDomain.xqid = this.villagePickers[0].id;
          that.buildingParams.communityId = that.villagePickers[0].id;
          that.buildingParams.xqbm = that.villagePickers[0].xqbm;
          that.housesParams.communityId = that.villagePickers[0].id;
          that.xqmc = that.villagePickers[0].xqmc;
          that
            .post(
              "api-apmuc/buildingRest/queryBuildingByCid",
              that.buildingParams
            )
            .then(r => {
              if (r.data.buildingInfo.length) {
                that.hasBuildings = true;
                that.buildingsPickers = r.data.buildingInfo;
                // that.building = that.buildingsPickers[0].buildingId;
              }
            });
        }
      });
  },
  methods: {
    // 小区选择
    villagePickersrChange() {
      var that = this;
      that.villagePickers.map((item, i) => {
        if (item.id == that.submitData.visitorsRecordDomain.xqid) {
          that.buildingParams.communityId = item.id;
          that.buildingParams.xqbm = item.xqbm;
          that.xqmc = item.xqmc;
        }
      });
      that
        .post("api-apmuc/buildingRest/queryBuildingByCid", that.buildingParams)
        .then(res => {
          if (res.data.buildingInfo.length) {
            that.housesParams.communityId = res.data.communityInfo.id;
            that.hasBuildings = true;
            that.buildingsPickers = res.data.buildingInfo;
            that.submitData.visitorsRecordDomain.ldid = null;
            that.hasUnit = false;
            that.hasLevel = false;
            that.hasHouse = false;
          } else {
            that.hasBuildings = false;
            that.hasUnit = false;
            that.hasHouse = false;
          }
        });
    },
    // 楼栋选择
    buildingsPickerChange() {
      var that = this;
      that.buildingsPickers.map((item, i) => {
        if (item.buildingId == that.submitData.visitorsRecordDomain.ldid) {
          that.ldmc = item.buildingLabel;
          that.housesParams.buildingId = item.buildingId;
          // 新接口数据处理 start
          var centerArr = new Array();
          for (var index = 0; index < item.unitObjs.length; index++) {
            centerArr.push(item.unitObjs[index].dyName);
          }
          // 新接口数据处理 end
          var unitObj = centerArr;
          var arr = new Array();
          var arr1 = new Array();
          for (var i = 0; i < unitObj.length; i++) {
            for (var key in unitObj[i]) {
              // arr1.push(key);
              arr1.push(unitObj[i]);
              // 排序 从小到大
              var min;
              for (var q = 0; q < arr1.length; q++) {
                for (var j = q; j < arr1.length; j++) {
                  if (arr1[q] > arr1[j]) {
                    min = arr1[j];
                    arr1[j] = arr1[q];
                    arr1[q] = min;
                  }
                }
              }
              that.unitObj = unitObj;
              // 排序 从小到大
            }
          }
          for (var a in arr1) {
            arr.push({
              unitname: arr1[a] + "单元",
              unitNo: arr1[a]
            });
          }
          that.unitPickers = arr;
          if (that.unitPickers.length) {
            that.hasUnit = true;
            that.hasHouse = false;
          } else {
            that.hasUnit = false;
            that.hasHouse = false;
          }
          that.unit = null;
        }
      });
    },
    // 单元选择
    unitPickerChange() {
      var that = this;
      that.unitPickers.map((item, i) => {
        if (item.unitNo == that.unit) {
          that.housesParams.dyh = item.unitNo;
          that.dyh = item.unitNo + "单元";
        }
      });

      that
        .post("api-apmuc/houseRest/queryHouses", that.housesParams)
        .then(res => {
          for (var i in res.data) {
            if (res.data[i].roomNo.substring(0, 1) == "-") {
              res.data[i].roomNo = "负" + res.data[i].roomNo.substring(1, 4);
            }
          }
          that.housePickers = res.data;
          that.submitData.visitorsRecordDomain.fwid = null;
          if (that.housePickers.length) {
            that.hasHouse = true;
          } else {
            that.hasHouse = false;
          }
        });
    },
    //房屋选择
    housePickerChange() {
      var that = this;
      that.housePickers.map((item, i) => {
        if (item.id == that.submitData.visitorsRecordDomain.fwid) {
          that.room = item.roomNo;
        }
      });
    },

    // 人脸照片上传回调方法
    callbackFace(e) {
      this.chooseFacePic(e);
    },
    // 人脸照片上传
    updateFacePic(e) {
      this.getPic(e.target.files[0], this.callbackFace);
    },
    // 人脸照片上传子方法
    chooseFacePic(e) {
      let baseStr = e.split("base64,")[1];
      const that = this;
      that.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "上传中..."
      });
      that.a.picData = baseStr;
      // 判断有没有人脸
      that
        .post("api-algo/frpRest/faceDetect", that.a)
        .then(res => {
          that.hideFloat();
          if (res.status == 0) {
            if (res.data.length > 1) {
              that.$toast.fail("请上传单张人脸!");
              return false;
            }
            // 判断有没有人脸（活体）
            that
              .post("api-algo/frpRest/faceLiveDetect", that.a)
              .then(r => {
                if (r.data == null) {
                  that.$toast.fail("请上传正确的人脸照片！");
                } else {
                  /* if (!r.data.alive) {
                    that.$toast.fail(
                      "照片不符合标准，请调整光线和角度重新拍摄！"
                    );
                    return false;
                  } */
                  that.submitData.ryzp =
                    "data:image/jpeg;base64," + r.data.picture;
                  that.$toast.clear();
                }
              })
              .catch(r => {
                that.$toast.fail("照片不符合标准，请调整光线和角度重新拍摄！");
              });
          } else {
            // 人脸旋转
            that
              .post("api-algo/frpRest/faceDetectRotate", that.a)
              .then(r => {
                if (r.data) {
                  let pic = r.data.picData;
                  // 人脸（活体）检测
                  that
                    .post("api-algo/frpRest/faceLiveDetect", pic)
                    .then(r => {
                      if (r.data == null) {
                        that.$toast.fail("请上传正确的人脸照片！");
                      } else {
                        that.submitData.ryzp =
                          "data:image/jpeg;base64," + r.data.picture;
                        that.$toast.clear();
                      }
                    })
                    .catch(r => {
                      that.$toast.fail(
                        "照片不符合标准，请调整光线和角度重新拍摄！"
                      );
                    });
                } else {
                  that.$toast.fail("请上传正确的人脸照片！");
                }
              })
              .catch(r => {
                that.$toast.fail("照片不符合标准，请调整光线和角度重新拍摄！");
              });
          }
        })
        .catch(r => {
          that.hideFloat();
          // 人脸旋转
          that
            .post("api-algo/frpRest/faceDetectRotate", that.a)
            .then(r => {
              if (r.data) {
                let pic = r.data.picData;
                // 人脸（活体）检测
                that
                  .post("api-algo/frpRest/faceLiveDetect", pic)
                  .then(r => {
                    if (r.data == null) {
                      that.$toast.fail("请上传正确的人脸照片！");
                    } else {
                      that.submitData.ryzp =
                        "data:image/jpeg;base64," + r.data.picture;
                      that.$toast.clear();
                    }
                  })
                  .catch(r => {
                    that.$toast.fail(
                      "照片不符合标准，请调整光线和角度重新拍摄！"
                    );
                  });
              } else {
                that.$toast.fail("请上传正确的人脸照片！");
              }
            })
            .catch(r => {
              // console.log(r.response.data.errMsg);
              that.$toast.fail(r.response.data.errMsg);
            });
        });
    },

    // 提交方法
    submit() {
      if (!this.submitData.ryzp) {
        this.$dialog.alert({
          title: "提示",
          message: "请上传人脸照"
        });
        return;
      }

      if (!this.submitData.xm) {
        this.$dialog.alert({
          title: "提示",
          message: "请填写姓名"
        });
        return;
      }

      if (!this.submitData.zjhm) {
        this.$dialog.alert({
          title: "提示",
          message: "请填写身份证号码"
        });
        return;
      } else {
        if (
          !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
            this.submitData.zjhm
          )
        ) {
          this.$dialog.alert({
            title: "提示",
            message: "请填写正确的身份证号码"
          });
          return;
        }
      }

      if (!this.submitData.sjhm) {
        this.$dialog.alert({
          title: "提示",
          message: "请填写手机号"
        });
        return;
      } else {
        if (!/^1[3456789]\d{9}$/.test(this.submitData.sjhm)) {
          this.$dialog.alert({
            title: "提示",
            message: "请填写正确的手机号码"
          });
          return;
        }
      }
      if (
        this.submitData.visitorsRecordDomain.xqid == null ||
        this.submitData.visitorsRecordDomain.ldid == null ||
        this.submitData.visitorsRecordDomain.fwid == null
      ) {
        this.$dialog.alert({
          title: "提示",
          message: "请将房屋信息填写完整"
        });
        return;
      }

      if (this.touched) {
        this.touched = false;
        this.submitData.visitorsRecordDomain.fwxx =
          this.xqmc + this.ldmc + this.dyh + this.room;
        this.post("api-apmuc/visitorsRest/insertVisitorsList", this.submitData)
          .then(res => {
            if (res.status == 0) {
              this.$toast.success({
                message: "添加成功",
                duration: 5000
              });
              this.submitData = {
                visitorsRecordDomain: {
                  jllx: 2, //记录类型
                  fklx: null, //访客类型
                  jlrid: 1, //记录人id
                  fwid: null, // 房屋id
                  fwxx: null, //房屋信息
                  ldid: null, //楼栋id
                  xqid: null // 小区id
                },
                xm: null,
                ryzp: null,
                zjhm: null,
                sjhm: null,
                fwzt: 1
              };
              this.hasBuildings = false;
              this.hasUnit = false;
              this.hasHouse = false;
              this.touched = true;
            } else {
              this.$toast(res.errMsg);
              this.touched = true;
            }
          })
          .catch(r => {
            this.$toast.fail("添加失败");
            this.touched = true;
          });
      }
    },
    // 显示悬浮框
    showFloat(e) {
      if (e == 1) {
        this.showId = true;
      } else {
        this.showFace = true;
      }
    },
    // 隐藏悬浮框
    hideFloat() {
      this.showId = false;
      this.showFace = false;
    },
    // 点击图片可放大
    showPic() {},
    // 删除图片
    DelImg(e) {
      this.$dialog
        .confirm({
          title: "删除图片",
          message: "确定要删除这张图片吗",
          confirmButtonColor: "#2dc5e0"
        })
        .then(() => {
          this.submitData.ryzp = null;
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.personalMsg {
  width: 90%;
  margin: 15px auto;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px #ccc;
}
.personalMsg-title {
  width: 90%;
  margin: 15px auto;
  font-size: 16px;
}
.personalMsg-title > img {
  width: 30px;
  height: 22.5px;
  position: relative;
  top: 5px;
}
.personalMsg-title > span {
  margin-left: 15px;
}
.owner-item {
  width: 90%;
  margin: 0 auto;
  border-bottom: 1px solid #e6e6e6;
  padding: 15px 0;
  display: flex;
  font-size: 16px;
  align-items: center;
}
.owner-item:last-child {
  border-bottom: none;
}
.owner-item > div:nth-child(2) {
  position: relative;
  left: 15px;
}
.owner-item > div > span {
  width: 85px;
  display: flex;
  align-items: center;
}
.owner-item > div > input {
  width: 70%;
  text-align: right;
  color: #666;
  /* font-weight: normal; */ /* display: inline-block;*/
  top: 5px;
  position: relative;
  z-index: 0;
  border: none;
  font-size: 16px;
}
.type_select {
  width: 180px;
  font-size: 16px;
  height: 26px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #fff;
  direction: rtl;
}
.house_select {
  width: 130px;
  font-size: 16px;
  height: 26px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #fff;
  direction: rtl;
}
.owner-pic {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
}
.norotate {
  width: 100%;
  height: 100%;
}
.owner-pic > div {
  width: 130px;
  height: 130px;
  margin: 15px 0;
  border: 1px dashed #ccc;
  text-align: center;
  color: #ccc;
  overflow: hidden;
}
.jia {
  display: block;
  position: relative;
  top: 22px;
  font-size: 40px;
}
.text {
  display: block;
  position: relative;
  top: 25px;
  font-size: 16px;
}
.picker {
  width: 90%;
  margin: 0 auto;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px #ccc;
  margin-bottom: 25px;
  font-size: 16px;
}
.picker-select {
  color: #666;
  height: 40px;
  display: flex;
  align-items: center;
}
.picker-select > text {
  margin-right: 12rpx;
}
.houseMsg-title {
  width: 90%;
  margin: 15px auto;
  font-size: 16px;
}
.houseMsg-title > img {
  width: 35px;
  height: 22px;
  position: relative;
  top: 5px;
}
.houseMsg-title > span {
  margin-left: 10px;
}
.picker-item {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #e6e6e6;
}
.picker-item:last-child {
  border-bottom: none;
}
.carMsg-title {
  width: 90%;
  margin: 15px auto;
  font-size: 16px;
}
.carMsg-title > img {
  width: 26px;
  height: 23px;
  position: relative;
  top: 5px;
}
.carMsg-title > span {
  margin-left: 10px;
}
.submit-btn {
  width: 90%;
  height: 50px;
  margin: 15px auto;
  background: #2dc5e0;
  color: #fff;
  font-size: 18px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.submit-btn > button {
  background: #2dc5e0;
  color: #fff;
  font-size: 18px;
}
.showId {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
}
.showId-view {
  width: 90%;
  height: 218px;
  background: white;
  margin: 0 auto;
  position: relative;
  top: 36%;
  text-align: center;
}
.showId-view > img {
  width: 282px;
  height: 120px;
  margin-top: 31px;
}
.close {
  width: 25px;
  height: 25px;
  float: right;
  position: relative;
  top: 0;
  right: 10px;
}
.close > img {
  width: 10px;
  height: 10px;
}
.showId-btn {
  width: 60%;
  height: 35px;
  margin: 0 auto;
  background: #2dc5e0;
  color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  margin-top: 10px;
}
.file {
  width: 60%;
  height: 35px;
  margin: 0 auto;
  background: #2dc5e0;
  color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  text-indent: 0;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.DelImg {
  width: 0% !important;
  height: 0rpx !important;
  margin: 30rpx !important;
  border: none !important;
  text-align: none !important;
  color: none !important;
  /* position: absolute; */
}
.rotateDelImg {
  width: 0% !important;
  height: 0rpx !important;
  margin: 30rpx !important;
  border: none !important;
  text-align: none !important;
  color: none !important;
  /* position: absolute; */
}
.DelImg > img {
  width: 14px;
  height: 14px;
  background: #ccc;
  opacity: 0.6;
  position: relative;
  top: -140px;
  left: 115px;
}
</style>
